import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AppConfig } from 'src/app/configs/app.config';
import { AdspDealService } from 'src/app/core/services/adsp-deal.service';
import { AdspDealAdminStateOptions, AdspDealMediaOptions, AdspDealPriceOptions,
  AdspDealStatusOptions, AdspDealTypeOptions
} from 'src/app/models/adsp-deals';

@Component({
  selector: 'app-adsp-view-deal',
  templateUrl: './adsp-view-deal.component.html',
  styleUrls: ['./adsp-view-deal.component.scss']
})
export class AdspViewDealComponent implements OnInit {

  sellerDataSource = new MatTableDataSource();
  @ViewChild("sellerTablePaginator") sellerTablePaginator: MatPaginator;
  @ViewChild("sellerTableSort") sellerTableSort: MatSort;
  sellerCount: number;
  readonly platformName!: string;

  sellerDetails: Array<any> = [];

  constructor(
    public dialogRef: MatDialogRef<any>,
    private adspDealService: AdspDealService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
      this.platformName = AppConfig.TITLE;
   }

  dealOptions:Array<any> = AdspDealTypeOptions;

  mediaOptions: Array<any> = AdspDealMediaOptions;

  sellerColumns : string[] = ["seller_name", "bid_request_volume_rate"]

  priceOptions: Array<any> = AdspDealPriceOptions;

  dealStatusOptions: Array<any> = AdspDealStatusOptions;

  dealAdminStatusOptions: Array<any> = AdspDealAdminStateOptions;

  ngOnInit(): void {
    this.getDealsByID()
  }

  getDealsByID() {
    this.adspDealService.getById(this.data.deal.id, this.data.globalParams).subscribe(res => {
      this.sellerDetails = res.data.seller_details;
    }, () => { }, () => {
      this.sellerDetails.push({
        seller_name: 'Other',
        bid_request_volume_rate: 1 - this.sellerDetails.reduce((acc, obj) => acc + obj.bid_request_volume_rate, 0)
      });
      this.sellerCount = this.sellerDetails.length;
      this.updateTable();
    })
  }

  updateTable() {
    this.sellerDataSource = new MatTableDataSource(this.sellerDetails);
    this.sellerDataSource.paginator = this.sellerTablePaginator;
    this.sellerDataSource.sort = this.sellerTableSort;
    this.sellerDataSource._updatePaginator(this.sellerCount);
  }

  closeModel() {
    this.dialogRef.close({
      event: "save",
      save: true,
    });
  }

}
